import { SpeedUnitLimit } from "@/app/activity/components/deviceTimeline/type"

export const speedUnitLimits: SpeedUnitLimit = {
  "km/h": {
    limit: 25.0,
    chartSpeedLimit: 40.0,
  },
  "m/s": {
    limit: 7.0,
    chartSpeedLimit: 11.0,
  },
  mph: {
    limit: 16.0,
    chartSpeedLimit: 24.0,
  },
  "yd/min": {
    limit: 455.0,
    chartSpeedLimit: 710.0,
  },
  "yd/s": {
    limit: 8.0,
    chartSpeedLimit: 12.0,
  },
  "ft/s": {
    limit: 23.0,
    chartSpeedLimit: 36.0,
  },
}
